import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { WidgetMacroRendererProps } from './WidgetMacroRenderer.ts';

export const WidgetMacroHandler: LoadableType<WidgetMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WidgetMacro" */ '../src/WidgetMacroRenderer.tsx'))
			.WidgetMacroRenderer,
});

export type { WidgetMacroRendererProps } from '../src/WidgetMacroRenderer.tsx';
